import { useState } from 'react'

import Styles from '../Photos/Photos.module.scss'
import ImageMenuModalStyles from '../ImageMenuModal.module.scss'

import { Modal } from 'almanac-ui/Modal'
import { useDebounce } from 'hooks/useDebounce'
import { SearchField } from 'components/ImagePickerModal/SearchField/SearchField'
import { LoadingState } from 'components/ImagePickerModal/LoadingState/LoadingState'
import { Grid } from 'components/ImagePickerModal/Grid/Grid'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'
import { ScrollContainer } from 'components/ImagePickerModal/ScrollContainer/ScrollContainer'
import { useImageMenuContext } from '../ImageMenuContext'
import { Actions } from '../ImageMenuModal'
import { getVideoMimeType } from 'components/Design/UploadsTab/components/StockVideosGallery'
import { SelectableFile } from '../SelectableFile/SelectableFile'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { useStockVideos } from 'hooks/queries/designer/useStockVideos'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const Videos = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { selectedImages, toggleSelectedImage, setProvider, initialQuery } = useImageMenuContext()
  const [query, setQuery] = useState(initialQuery || '')
  const debouncedQuery = useDebounce(query, 500)

  const {
    data,
    isLoading: isStockVideosLoading,
    hasNextPage,
    fetchNextPage,
  } = useStockVideos({
    query: debouncedQuery,
    pageSize: 6,
    videoType: 'all',
  })

  const videos = data?.pages.flatMap((page) => page.videos) || []

  const videoFiles = videos.map((video) => ({
    id: video.id,
    url: video.videos.medium.url,
    source_url: video.videos.medium.url,
    thumbnail_url: video.videos.medium.thumbnail,
    duration: video.duration,
    variants: [],
    mime_type: video.videos.medium.mime_type ?? getVideoMimeType(video.videos.medium.url),
    title: video.id,
    preview_variant_url: video.videos.tiny.url,
  }))

  return (
    <>
      <Modal.Header
        className={ImageMenuModalStyles.header}
        actions={<Actions />}
        title="Insert Videos"
        onBack={() => setProvider('')}
      />
      <div className={Styles.searchContainer}>
        <SearchField value={query} onChange={setQuery} />
      </div>
      <Modal.Content className={Styles.content} withoutFooter={isSystemRedesignEnabled}>
        <div className={Styles.photos} data-testid="videos-provider">
          {isStockVideosLoading && (
            <div className={Styles.loading}>
              <LoadingState />
            </div>
          )}

          {!isStockVideosLoading && videos.length > 0 && (
            <ScrollContainer>
              <Grid.Root breakpointCols={4}>
                {videoFiles.map((video) => (
                  <Grid.Thumbnail key={video.id}>
                    <SelectableFile
                      key={video.id}
                      onSelect={() => toggleSelectedImage({ ...video, provider: 'stockVideo' })}
                      isSelected={selectedImages.some((i) => i.url === video.url)}
                    >
                      <div className={Styles.videoContainer}>
                        <img key={video.id} src={video.thumbnail_url} alt={video.thumbnail_url} />
                        {video.duration && <VideoDuration duration={video.duration} />}
                      </div>
                    </SelectableFile>
                  </Grid.Thumbnail>
                ))}
              </Grid.Root>
              {hasNextPage && (
                <div className={Styles.infiniteLoader}>
                  <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage} />
                </div>
              )}
            </ScrollContainer>
          )}
        </div>
      </Modal.Content>
    </>
  )
}
